document.addEventListener("DOMContentLoaded", () => {
    const sortForm = document.querySelector('.sort-dropdown-container');
    if (sortForm) {
        sortForm.addEventListener('change', function(e) {
            if (e.target.name === 'sort_by') {
                const selectedSort = e.target.value;
                const currentUrl = new URL(window.location.href);
                
                currentUrl.searchParams.set('sort_by', selectedSort);
                window.location.href = currentUrl.toString();
            }
        });
    }
});

document.addEventListener("DOMContentLoaded", () => {
    if (!window.plpStickyFilters) return;
    const filterBar = document.querySelector('.filter-bar__filters-inner');
    const header = document.querySelector('#shopify-section-header');
    const announcementBar = document.querySelector('#shopify-section-announcement-bar');
    const componentToScroll = document.querySelector('.collection.section') ;

    let headerHeight, announcementBarHeight, totalHeight, heightToScroll;

    function recalculateHeights() {
        headerHeight = header.offsetHeight;
        announcementBarHeight = announcementBar.offsetHeight;
        heightToScroll = componentToScroll.offsetHeight | headerHeight + announcementBarHeight;
        totalHeight = headerHeight + announcementBarHeight;
    }

    recalculateHeights();

    let hasFixed = false;

    function handleScroll() {
        const scrollPosition = window.scrollY;

        if (scrollPosition > heightToScroll && !hasFixed) {
            filterBar.style.top = `${totalHeight - 1}px`;
            filterBar.style.position = 'fixed';
            hasFixed = true;
        } else if (scrollPosition <= heightToScroll && hasFixed) {
            filterBar.style.position = 'relative';
            filterBar.style.top = '0';
            hasFixed = false;
        }
    }

    window.addEventListener('scroll', handleScroll);

    window.addEventListener('resize', () => {
        recalculateHeights();
        handleScroll();
    });
});
